import { type LiveSessionAction } from "../../../ports/primary/ui/formatters/liveSessionActions"

/**
 * Les gestes que l'élève a sur une séance : les deux branches de son « Gérer le rdv » d'aujourd'hui
 * (signaler un retard, décaler la séance), et défaire l'un ou l'autre. Ni « Écrire à … » (le
 * composeur est au parent, l'élève a la messagerie), ni « Annuler le rattrapage ».
 *
 * `report_absence` est la face « moins de 2 h » de `move_session` — la même intention, que son
 * formulaire d'aujourd'hui accepte encore à ce délai : la retirer lui ôterait un geste qu'il a.
 *
 * La règle par rôle rejoindra `sessionActions` au câblage ; d'ici là elle vit ici, à côté de la
 * feuille qui la lit.
 */
export const STUDENT_SESSION_ACTIONS: readonly LiveSessionAction[] = [
    "move_session",
    "report_absence",
    "report_late",
    "cancel_absence",
    "cancel_late",
]

/**
 * Les mêmes, plus l'entrée en live — là où la séance porte aujourd'hui son bouton « GO ! »
 * (« Messages »). « Tous mes lives » ne l'a pas.
 */
export const STUDENT_SESSION_ACTIONS_WITH_JOIN: readonly LiveSessionAction[] = [
    "join_as_child",
    ...STUDENT_SESSION_ACTIONS,
]

/**
 * Ce que la feuille montre : ce que l'état de la séance permet, moins ce que le rôle n'a pas.
 * `allowed` absent ne retire rien (le parent) ; l'ordre est celui de l'état, jamais celui du rôle.
 */
export function actionsForRole(
    actions: readonly LiveSessionAction[],
    allowed?: readonly LiveSessionAction[]
): LiveSessionAction[] {
    return actions.filter((action) => allowed == null || allowed.includes(action))
}
